export default {
    current_choice: 'Моментален избор',
    book_now: 'Резервирај сега',
    minimum_age: 'Само за лица над {age} години',
    excess_liability: 'Одговорност за вишок',
    security_deposit: 'Сигурносен депозит',
    fuel_policy: 'Политика на гориво',
    like_for_like: 'Исто за исто',
    full_to_full: 'Полн резервоар до полн резервоар',
    miles_per_rental: '{mileage} бесплатни мили по изнајмување',
    km_per_rental: '{mileage} бесплатни километри по изнајмување',
    unlimited_mileage: 'Неограничен број мили',
    unlimited_mileage_km: 'Неограничени километри',
    non_amendable: 'Неизмениво',
    non_refundable: 'Неисплативо',
    free_cancellation_until: 'Бесплатно откажување до',
    cancellation_in_line_with: 'Откажување во согласност со',
    tcs: 'Услови и услови',
    free_extras_on_collection: 'Два бесплатни дополнителни на земање',
    glass_and_tyres_covered: 'Покриени стакло и гуми',
    number_of_passengers: 'Број на патници',
    number_of_bags: 'Број на торби',
    fuel_type: 'Тип на гориво',
    co2: 'CO2',
    aircon: 'Клима уред',
    transmission: 'Предавање',
    book_type: 'Резервирај {type}',
    debit_card_deposit: 'Прифаќање на дебитни картички за депозити'
}
